export const NAME = 'session';
export const SESSION_KEY = 'session';



// WEBPACK FOOTER //
// ./src/redux/modules/session/constants.js